import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ReactComponent as Logo } from '../../../assets/images/popashot_logo.svg';
import ErrorMessage from '../../common/ErrorMessage';
import LoadingButton from '../../common/LoadingButton';
import apiClient from '../../../utils/apiClient';
import { useLoading } from '../../../contexts/LoadingContext';

const ResetPasswordStep = ({ email, onBack }) => {
    const [error, setError] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const { startLoading, stopLoading } = useLoading();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        startLoading('resetPassword');

        try {
            await apiClient.post('/api/users/auth/request-password-reset/', {
                email: email
            });
            setIsSuccess(true);
        } catch (error) {
            setError(error.response?.data?.detail || 'Failed to send reset instructions');
        } finally {
            stopLoading('resetPassword');
        }
    };

    if (isSuccess) {
        return (
            <div className="space-y-8 bg-transparent">
                <div className="flex items-center justify-center">
                    <Logo className="w-48 h-auto" />
                </div>

                <div className="text-center space-y-4">
                    <h1>Instructions sent!</h1>
                    <p>
                        If a Pop-A-Shot account exists for {email}, instructions for resetting your password will be sent to it.
                    </p>
                    <p className="text-sm text-gray-600">
                        You'll receive this email within 5 minutes. Be sure to check your spam folder, too.
                    </p>
                    <button
                        onClick={onBack}
                        className="mt-4 text-sm text-popashot-blue-light hover:text-popashot-blue"
                    >
                        Return to login
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-8 bg-transparent">
            <div className="flex items-center justify-center">
                <Logo className="w-48 h-auto" />
            </div>

            <div className="text-center">
                <h1>Reset password</h1>
                <p className="mt-4">Reset your password to access your account</p>
            </div>

            <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                <div>
                    <label htmlFor="email" className="sr-only">
                        Email Address
                    </label>
                    <input
                        id="email"
                        name="email"
                        type="email"
                        required
                        className="appearance-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                        value={email}
                        disabled
                    />
                </div>

                <ErrorMessage error={error} />

                <div className="space-y-3">
                    <LoadingButton
                        type="submit"
                        className="w-full btn-primary"
                        loadingKey="resetPassword"
                    >
                        Reset password
                    </LoadingButton>
                    <button
                        type="button"
                        onClick={onBack}
                        className="w-full text-sm text-popashot-blue-light hover:text-popashot-blue"
                    >
                        Back to login
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ResetPasswordStep;
